import aws4 from 'aws4';
import getCredentials from 'utils/getCredentials';
import { withDevIdentity } from 'utils/devIdentity';

export const createSignedRequest = async (request, credentials) => {
  if (!credentials) credentials = await getCredentials();
  const { accessKeyId, secretAccessKey, sessionToken } = credentials;

  // No-op unless this is a localhost request from a dev build. Applied here
  // because every service reaches the API through this one function, whether
  // via createSignedRequestsHelpers, an API_URL constants file, or a
  // hand-built request object.
  request = withDevIdentity(request);

  const signer = new aws4.RequestSigner(request, {
    accessKeyId,
    secretAccessKey,
    sessionToken,
  });
  const signedRequest = signer.sign();
  signedRequest.headers.Accept = '*/*';

  delete signedRequest.headers['Host'];
  delete signedRequest.headers['Content-Length'];

  return signedRequest;
};
